"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var Subject_1 = require("rxjs/Subject");
var meta_field_model_1 = require("../model/meta-field.model");
var operators_1 = require("rxjs/operators");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var meta_field_utils_1 = require("../../../utils/meta-field-utils");
var selected_meta_fields_model_1 = require("../model/selected-meta-fields.model");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var EditorBindFieldPopupComponent = /** @class */ (function () {
    function EditorBindFieldPopupComponent(data, kbService, dialogRef, cdr) {
        var _this = this;
        this.data = data;
        this.kbService = kbService;
        this.dialogRef = dialogRef;
        this.cdr = cdr;
        this._selectedMetaFieldName = null;
        this.fields = [new meta_field_model_1.MetaFieldModel('', '', '', 'ui_tb.editor.add_dynamic_data.binding_label')];
        this._emptyState = '';
        this._simpleMetaFields = [];
        this._destroy$ = new Subject_1.Subject();
        this.selectedMetaFields = [];
        this._selectedFieldsIndex = 0;
        this._selectedFields = [];
        this.condition = '';
        this.format = '';
        this._categoryName = data.categoryName;
        this._emptyState = data.emptyState || '';
        this.condition = data.condition || '';
        this.format = data.format || '';
        this._selectedFields = data.selectedMetaFieldBinding ? data.selectedMetaFieldBinding.split('.').slice(1) : [];
        this.getMetaFields(data.categoryName)
            .pipe(operators_1.takeUntil(this._destroy$)).subscribe(function (items) {
            if (_this._selectedFields.length !== 0) {
                var item = items.find(function (field) { return field['name'] === _this._selectedFields[_this._selectedFieldsIndex]; });
                _this.selectedMetaFields.push(new selected_meta_fields_model_1.SelectedMetaFieldsModel(item.name, items, item.metaFieldType));
                _this.fields.push(item);
                _this._selectedFieldsIndex++;
                if (_this._selectedFieldsIndex < _this._selectedFields.length) {
                    _this.extractFields(item.compoundName);
                }
            }
            else {
                _this._simpleMetaFields = items;
            }
        });
    }
    EditorBindFieldPopupComponent.prototype.extractFields = function (categoryName) {
        var _this = this;
        this.getMetaFields(categoryName)
            .pipe(operators_1.takeUntil(this._destroy$)).subscribe(function (items) {
            var item = items.find(function (field) { return field['name'] === _this._selectedFields[_this._selectedFieldsIndex]; });
            if (_this._selectedFieldsIndex < _this._selectedFields.length) {
                _this.selectedMetaFields.push(new selected_meta_fields_model_1.SelectedMetaFieldsModel(item.name, items, item.metaFieldType));
                _this.fields.push(item);
            }
            else {
                _this._simpleMetaFields = items;
                _this._selectedMetaFieldName = null;
            }
            _this._selectedFieldsIndex++;
            if (_this._selectedFieldsIndex < _this._selectedFields.length || item.compoundName) {
                _this.extractFields(item.compoundName);
            }
        });
    };
    EditorBindFieldPopupComponent.prototype.getMetaFields = function (categoryName) {
        return this.kbService.getMetaFields(categoryName)
            .map(function (metaFields) {
            return meta_field_utils_1.getComboBoxItems(metaFields.filter(function (metaField) { return meta_field_utils_1.isSimpleField(metaField); }));
        });
    };
    EditorBindFieldPopupComponent.prototype.isDateField = function (field) {
        return field.metaFieldType === idm_kb_service_client_js_1.MetaFieldType.DATE || field.metaFieldType === idm_kb_service_client_js_1.MetaFieldType.DATE_TIME ||
            field.metaFieldType === idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE || field.metaFieldType === idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE_TIME;
    };
    EditorBindFieldPopupComponent.prototype.openMenu = function (sisSelect) {
        sisSelect.open();
    };
    EditorBindFieldPopupComponent.prototype.onSelect = function (metaField, index) {
        var _this = this;
        if (metaField) {
            if (index !== null) {
                this._simpleMetaFields = this.selectedMetaFields[index].metaFields;
                this.selectedMetaFields = this.selectedMetaFields.slice(0, index);
            }
            var selectedMetaField = this._simpleMetaFields
                .find(function (field) { return field['name'] === metaField; });
            this.selectedMetaFields.push(new selected_meta_fields_model_1.SelectedMetaFieldsModel(metaField, this.simpleMetaFields, selectedMetaField.metaFieldType));
            if (index != null && index < this.selectedMetaFields.length) {
                this.fields[index + 1] = selectedMetaField;
                this.fields = this.fields.slice(0, index + 2);
            }
            else {
                this.fields.push(selectedMetaField);
            }
            this._simpleMetaFields = [];
            if (selectedMetaField && selectedMetaField.compoundName) {
                this.getMetaFields(selectedMetaField.compoundName)
                    .pipe(operators_1.takeUntil(this._destroy$)).subscribe(function (items) {
                    _this._simpleMetaFields = items;
                });
            }
        }
    };
    EditorBindFieldPopupComponent.prototype.onClose = function () {
        this._emptySelectMenu.searchTerm = '';
        this._emptySelectMenu.reloadItems();
    };
    EditorBindFieldPopupComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    EditorBindFieldPopupComponent.prototype.save = function () {
        if (this.isValid()) {
            var selectedMetaFieldBinding = this._categoryName + "." + this.selectedMetaFields.map(function (item) { return item.selectedField; }).join('.');
            var isDateField = this.isDateField(this.selectedMetaFields[this.selectedMetaFields.length - 1]);
            this.dialogRef.close({
                selectedMetaFieldBinding: selectedMetaFieldBinding,
                emptyState: this.emptyState,
                condition: this.condition,
                format: this.format,
                isDateField: isDateField,
                type: this.format ? this.isDateField ? 'date' : 'number' : ''
            });
        }
    };
    EditorBindFieldPopupComponent.prototype.isValid = function () {
        this._metaFieldErrorFlag = this.selectedMetaFields.length === 0;
        return !this._metaFieldErrorFlag;
    };
    EditorBindFieldPopupComponent.prototype.isCategoryField = function (fieldType) {
        return fieldType === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY
            || fieldType === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY
            || fieldType === idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT
            || fieldType === idm_kb_service_client_js_1.MetaFieldType.PARENT
            || fieldType === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER
            || fieldType === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE
            || fieldType === idm_kb_service_client_js_1.MetaFieldType.USER;
    };
    EditorBindFieldPopupComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.unsubscribe();
    };
    Object.defineProperty(EditorBindFieldPopupComponent.prototype, "selectedMetaFieldName", {
        get: function () {
            return this._selectedMetaFieldName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorBindFieldPopupComponent.prototype, "isFormValid", {
        get: function () {
            return this.selectedMetaFields.length !== 0 && !this.isCategoryField(this.fields[this.fields.length - 1].metaFieldType);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorBindFieldPopupComponent.prototype, "emptyState", {
        get: function () {
            return this._emptyState;
        },
        set: function (value) {
            this._emptyState = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorBindFieldPopupComponent.prototype, "simpleMetaFields", {
        get: function () {
            return this._simpleMetaFields;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorBindFieldPopupComponent.prototype, "metaFieldErrorFlag", {
        get: function () {
            return this._metaFieldErrorFlag;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.ViewChild('metaFieldAdd'),
        __metadata("design:type", idm_ng_controls_1.SisSelectComponent)
    ], EditorBindFieldPopupComponent.prototype, "_emptySelectMenu", void 0);
    __decorate([
        core_1.ViewChildren('selected'),
        __metadata("design:type", core_1.QueryList)
    ], EditorBindFieldPopupComponent.prototype, "_selectMenusRef", void 0);
    EditorBindFieldPopupComponent = __decorate([
        core_1.Component({
            selector: 'sis-template-editor-bind-field-popup',
            template: require('./editor-bind-field-popup.component.html'),
            styles: [require('./editor-bind-field-popup.component.css')]
        }),
        __param(0, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [Object, idm_kb_service_client_js_1.KbService,
            material_1.MatDialogRef,
            core_1.ChangeDetectorRef])
    ], EditorBindFieldPopupComponent);
    return EditorBindFieldPopupComponent;
}());
exports.EditorBindFieldPopupComponent = EditorBindFieldPopupComponent;
//# sourceMappingURL=editor-bind-field-popup.component.js.map